<script setup lang="ts">

import {computed, ref} from "vue";
import {useLoginInfoStore} from "@/stores/loginInfo";
import Translator from "@/utils/common/Translator";
import NoItems from "@/components/navBar/approvals/NoItems.vue";
import ApprovalPopupItem from "@/components/navBar/approvals/ApprovalPopupItem.vue";
import {storeToRefs} from "pinia";
import RouteNames from "@/router/RouteNames.ts";
import router from "@/router";
import DomainBaseEntities from "@/utils/constants/DomainBaseEntities.ts";
import ListPlace from "@/utils/presenters/ListPlace.ts";
import ConstantViewNames from "@/utils/constants/ConstantViewNames.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import DTOApprovalCase = namaTypes.DTOApprovalCase;

let {approvals, approvalsCount} = storeToRefs(useLoginInfoStore());
let isPopupVisible = ref(false);

const viewAllApprovalsLink = computed(() => {
  let place = new ListPlace();
  place.entityType = DomainBaseEntities.ApprovalDefinition;
  place.listViewName = ConstantViewNames.EMPLOYEE_APPROVALS_SCREEN_NAME;
  return router.resolve({
    name: RouteNames.LIST_VIEW_ROUTE,
    query: place.fetchQuery()
  }).href;
});

</script>

<template>
  <div class="tw-flex tw-justify-center">
    <div :title="Translator.translateId('approval')"
         class="tw-relative focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-white/75 hover:tw-cursor-pointer">
      <NamaIcon default-icon="nm-approve" class="tw-size-6 compact:tw-size-[22px] ultra:tw-size-5"/>
      <span v-if="approvalsCount>0" v-text="approvalsCount > 99 ? '+99' : approvalsCount"
            class="tw-absolute tw-bg-red-600 tw-rounded-[25%] tw-text-sm ultra:tw-text-xs tw-p-1 ultra:tw-p-0.5 tw-text-namaFontColor-dark tw--top-1/3 tw-left-3/4 tw-leading-[10px]"/>
    </div>
    <q-menu v-if="useLoginInfoStore().isLoggedIn" v-model="isPopupVisible" self="top middle" :offset=[40,15] id="approvalsMenu"
            class="tw-max-h-screen">
      <div class="tw-flex tw-flex-col tw-max-h-[60vh] tw-w-full desktop:tw-max-w-[70vw] desktop:tw-min-w-96">
        <div>
          <ApprovalPopupItem v-for="(approval, index) in approvals" :key="index" :approval="approval.values as DTOApprovalCase"/>
          <NoItems v-if="!approvals||approvals.length==0" :message="Translator.translateId('noNewApprovals')"/>
        </div>
        <div class="tw-w-full flex">
          <a
            class="tw-w-full tw-bg-[#4b5563] dark:tw-bg-black tw-rounded-t-none tw-text-base tw-p-2 tw-leading-tight tw-rounded-b-[4px] tw-font-bold tw-text-namaFontColor-dark tw-cursor-pointer tw-text-center"
            :href="viewAllApprovalsLink">
            {{ Translator.translateId('viewAllApprovals') }}
          </a>
        </div>
      </div>
    </q-menu>
  </div>
</template>

<style>
#approvalsMenu {
  @apply dark:tw-bg-namaBackground-deep-dark
}
</style>
